import type React from "react";
import { type DetailedHTMLProps, type HTMLAttributes } from "react";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { useScript } from "~/common/hooks/useScript";
import { isWebComponentEnabled, WebcomponentToggle } from "~/features/productDetails/components/usePDPTabs";
import classNames from "classnames";
import { NumberFormatter } from "~/common/utils/NumberFormatter";

interface MountingManagerTabProps {
  mountingManagerURL: string;
  designation?: string;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "mounting-manager": DetailedHTMLProps<
        HTMLAttributes<HTMLElement> & {
          bearing?: string;
          language?: string;
          separator?: "point" | "comma";
        },
        HTMLElement
      >;
    }
  }
}

const MountingManagerTab: React.FC<MountingManagerTabProps> = ({ mountingManagerURL, designation }) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  useScript(window.SCHA.urls.mountingMgrWebComponent);

  return (
    <div
      className={classNames("scha__ignore-margins", {
        "w-100": !isDesktop,
      })}
    >
      {isWebComponentEnabled(WebcomponentToggle.MOUNTING_MANAGER) ? (
        <mounting-manager
          bearing={designation}
          language={CURRENT_LANGUAGE}
          separator={NumberFormatter.getDecimalSeparatorName()}
        />
      ) : (
        <iframe className="scha__pdp-iframe" id="mmIframe" src={mountingManagerURL} scrolling="yes" />
      )}
    </div>
  );
};

export default MountingManagerTab;
